import React, { useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import { DetailCard } from '@tecuity/granite-ui/DetailCard'
import { Detail } from '@tecuity/granite-ui/Detail'
import format from 'date-fns/format'
import { ContextButton } from '@tecuity/granite-ui'
import PencilIcon from '@tecuity/sos-icons/react/pencil'
import ArchiveIcon from '@tecuity/sos-icons/react/archive'
import CheckBoxIcon from '@tecuity/sos-icons/react/checkbox'
import CrossIcon from '@tecuity/sos-icons/react/cross-heavy'
import CaretDownIcon from '@tecuity/sos-icons/react/caret-down'
import CaretUpIcon from '@tecuity/sos-icons/react/caret-up'
import { ConfirmDialog } from 'components/Modal/Modal'
import { setErrorToast } from '../../actions'
import { GET_NOTE_HISTORY } from '../../requests'
import { GraniteDataGrid } from '@tecuity/granite-ui/GraniteDataGrid'
import { useDispatch } from 'react-redux'

const NotesPanel = ({
  cardHeader = 'Notes',
  inputLabel = 'Note',
  saveNote = () => {
    console.warn('Add Note NOT tied in.')
  },
  editNote,
  deleteNote,
}) => {
  const dispatch = useDispatch()

  const { recordNotes } = useSelector((state) => state.record, shallowEqual)
  const { appUserRights } = useSelector((state) => state.auth, shallowEqual)
  const [noteText, setNoteText] = useState('')

  const [confirmDialogIsOpen, setConfirmDialogIsOpen] = useState(false)
  const [deletingNoteId, setDeletingNoteId] = useState(null)
  const toggleConfirmDialog = (note = null) => {
    if (!!note) {
      let noteID = !note.NOTE_ID ? note.NoteId : note.NOTE_ID
      setDeletingNoteId(noteID)
    } else {
      setDeletingNoteId(null)
    }
    setConfirmDialogIsOpen(!confirmDialogIsOpen)
  }

  const [editingNote, setEditingNote] = useState(null)

  const [noteHistoryNoteId, setNoteHistoryNoteId] = useState(null)
  const [noteHistories, setNoteHistories] = useState(null)

  const noteHistoryColumns = [
    {
      field: 'Username',
      flex: 1,
      headerName: 'User Name',
      disableColumnMenu: true,
    },
    {
      field: 'ChangedFrom',
      flex: 1,
      headerName: 'Changed From',
      disableColumnMenu: true,
    },
    {
      field: 'ChangedTo',
      flex: 1,
      headerName: 'Changed To',
      disableColumnMenu: true,
    },
    {
      field: 'ChangedOnDateFormatted',
      flex: 1,
      headerName: 'Changed On',
      disableColumnMenu: true,
    },
  ]

  useEffect(() => {
    if (!noteHistoryNoteId) {
      setNoteHistories(null)
      return
    }
    GET_NOTE_HISTORY(
      noteHistoryNoteId,
      (histories) => {
        for (let history of histories) {
          history.ChangedOnDateFormatted = format(
            new Date(history.ChangedOnDate),
            'MM/dd/yyyy hh:mm a'
          )
        }
        setNoteHistories(histories)
      },
      (err) => {
        dispatch(setErrorToast('Failed to fetch Note History'))
        console.error(err)
      }
    )
  }, [noteHistoryNoteId])

  return (
    <div style={{ width: '100%' }}>
      <h2 style={{ marginBottom: 15 }}>Notes</h2>
      <DetailCard label={cardHeader} className="detailsCard" style={{ marginBottom: '15px' }}>
        {appUserRights.includes('CreateNote') && (
          <div style={{ display: 'flex', flexDirection: 'row', padding: 10 }}>
            <div className={'note-text-area'} style={{ flexGrow: '4' }}>
              <label htmlFor={'noteTextArea'}>{inputLabel}</label>
              <textarea
                name={'noteTextArea'}
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
                rows={3}
              />
            </div>
            <ContextButton
              disabled={noteText === '' ? true : undefined}
              customCss={`margin-top: 16px; margin-left: 5px; text-transform: none !important; height: 46px;`}
              onClick={() => {
                saveNote(noteText)
                setNoteText('')
              }}
            >
              Add {inputLabel}
            </ContextButton>
          </div>
        )}
        {recordNotes && recordNotes.length > 0 ? (
          <div className="note-word-break">
            {(recordNotes || []).map((note, i) => {
              const parts = note.NoteText.split('\n')
              return (
                <div key={i}>
                  <Detail
                    label={`Note: ${note.NoteId} - ${note.LastModifiedUser} ${format(
                      new Date(note.LastModifiedDate),
                      'MM/dd/yyyy hh:mm a'
                    )}`}
                    fontSize="small"
                    customCss={`margin-bottom: 4px;`}
                  >
                    {!editingNote ||
                    (!note.NOTE_ID
                      ? editingNote.NoteId !== note.NoteId
                      : editingNote.NOTE_ID !== note.NOTE_ID) ? (
                      <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <div style={{ display: 'flex' }}>
                          {(parts || []).map((part, j) => {
                            return (
                              <React.Fragment key={'' + note.NOTE_ID + j}>
                                {part}
                                {j !== parts.length - 1 ? <br /> : null}
                              </React.Fragment>
                            )
                          })}
                        </div>

                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                          {(appUserRights.includes('EditNote') ||
                            appUserRights.includes('DeleteNote')) && (
                            <div>
                              {noteHistoryNoteId !==
                              (!note.NOTE_ID ? note.NoteId : note.NOTE_ID) ? (
                                <button
                                  className="btn btn-primary btn-text"
                                  onClick={() => {
                                    setNoteHistoryNoteId(!note.NOTE_ID ? note.NoteId : note.NOTE_ID)
                                  }}
                                  title={`Display Note History: ${note.NoteId}`}
                                  alt={`Display Note History: ${note.NoteId}`}
                                >
                                  <CaretDownIcon />
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary btn-text"
                                  onClick={() => {
                                    setNoteHistoryNoteId(null)
                                  }}
                                  title={`Hide Note History: ${note.NoteId}`}
                                  alt={`Hide Note History: ${note.NoteId}`}
                                >
                                  <CaretUpIcon />
                                </button>
                              )}
                            </div>
                          )}
                          {appUserRights.includes('EditNote') && (
                            <button
                              className="btn btn-primary btn-text"
                              onClick={() => {
                                setEditingNote(note)
                              }}
                              title={`Edit Note: ${note.NoteId}`}
                              alt={`Edit Note: ${note.NoteId}`}
                            >
                              <PencilIcon />
                            </button>
                          )}
                          {appUserRights.includes('DeleteNote') && (
                            <button
                              className="btn btn-primary btn-text btn-danger"
                              onClick={() => {
                                toggleConfirmDialog(note)
                              }}
                              title={`Delete Note: ${note.NoteId}`}
                              alt={`Delete Note: ${note.NoteId}`}
                            >
                              <ArchiveIcon />
                            </button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <div
                        className="edit-note note-text-area"
                        style={{ display: 'flex', flexDirection: 'row', width: '100%' }}
                      >
                        <div style={{flex: 1}}>
                          <label for="editNoteTextArea">Edit Note</label>
                          <textarea
                            aria-labelledby="editNoteTextArea"
                            name={'editNoteTextArea'}
                            value={editingNote.NoteText}
                            onChange={(e) =>
                              setEditingNote({ ...editingNote, NoteText: e.target.value })
                            }
                            rows={2}
                          />
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                          <button
                            className="btn btn-primary btn-text"
                            onClick={() => {
                              editNote(editingNote)
                              setEditingNote(null)
                            }}
                            alt={`Save Note: ${note.NoteId}`}
                            title={`Save Note: ${note.NoteId}`}
                          >
                            <CheckBoxIcon />
                          </button>
                          <button
                            className="btn btn-primary btn-text"
                            onClick={() => {
                              setEditingNote(null)
                            }}
                            title={`Cancel Editing Note: ${note.NoteId}`}
                            alt={`Cancel Editing Note: ${note.NoteId}`}
                          >
                            <CrossIcon />
                          </button>
                        </div>
                      </div>
                    )}
                  </Detail>
                  {(appUserRights.includes('EditNote') || appUserRights.includes('DeleteNote')) &&
                    !!noteHistories && (
                      <GraniteDataGrid
                        columns={noteHistoryColumns}
                        rows={noteHistories}
                        pagination={undefined}
                        rowsPerPageOptions={[25, 50, 100]}
                        checkboxSelection={false}
                        selectionModel={undefined}
                        getRowId={(row) => row.NoteHistoryId}
                      />
                    )}
                </div>
              )
            })}
          </div>
        ) : null}
      </DetailCard>
      {confirmDialogIsOpen && (
        <ConfirmDialog
          closeModal={toggleConfirmDialog}
          onModalClosed={() => {}}
          message="Are you sure you want to delete this note?"
          buttons={[
            { label: 'No', onClick: () => {}, className: 'btn-default' },
            {
              label: 'Yes',
              onClick: () => {
                deleteNote(deletingNoteId)
              },
              className: 'btn-danger',
            },
          ]}
          modalStyle={{ borderRadius: 3 }}
        />
      )}
    </div>
  )
}

export default NotesPanel
